import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/orders/Orders.vue'),
      meta: {
        pageTitle: 'Bienvenue',
        pageTitleEn: 'Welcome',
        breadcrumb: [
          {
            text: 'Accueil',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('@/views/analytics/Analytics.vue'),
      meta: {
        pageTitle: 'Statistiques',
        pageTitleEn: 'Analytics',
        breadcrumb: [
          {
            text: 'Statistiques',
            active: true,
          },
        ],
      },
    },
    {
      path: '/payouts',
      name: 'payouts',
      component: () => import('@/views/payouts/Payouts.vue'),
      meta: {
        pageTitle: 'Paiements',
        pageTitleEn: 'Payouts',
        breadcrumb: [
          {
            text: 'Historique des paiements',
            active: true,
          },
        ],
      },
    },
    {
      path: '/glasses',
      name: 'glasses',
      component: () => import('@/views/glass/Glasses.vue'),
      meta: {
        pageTitle: 'Mes produits',
        pageTitleEn: 'My products',
        breadcrumb: [
          {
            text: 'Mes produits',
            active: true,
          },
        ],
      },
    },
    {
      path: '/glasses/edit/:id',
      name: 'editGlass',
      component: () => import('@/views/glass/EditGlass.vue'),
      meta: {
        pageTitle: 'Mes produits',
        pageTitleEn: 'My products',
        breadcrumb: [
          {
            text: 'Mes produits',
            active: true,
          },
        ],
      },
    },
    {
      path: '/order-item/:id',
      name: 'orderItemView',
      component: () => import('@/views/orders/OrderItemViewer.vue'),
      meta: {
        pageTitle: 'Voir Order Item',
        pageTitleEn: 'Order item view',
        breadcrumb: [
          {
            text: 'Voir Order Item',
            active: true,
          },
        ],
      },
    },
    {
      path: '/promotions/edit/:id',
      name: 'editPromotion',
      component: () => import('@/views/promotion/EditPromotion.vue'),
      meta: {
        pageTitle: 'Modifier une promotion',
        pageTitleEn: 'Edit coupon',
        breadcrumb: [
          {
            text: 'Modifier une promotion',
            active: true,
          },
        ],
      },
    },
    {
      path: '/promotions/add',
      name: 'addPromotion',
      component: () => import('@/views/promotion/CreatePromotion.vue'),
      meta: {
        pageTitle: 'Ajouter une promotion',
        pageTitleEn: 'Add coupon',
        breadcrumb: [
          {
            text: 'Ajouter une promotion',
            active: true,
          },
        ],
      },
    },

    {
      path: '/promotions',
      name: 'promotions',
      component: () => import('@/views/promotion/Promotions.vue'),
      meta: {
        pageTitle: 'Codes promo',
        pageTitleEn: 'Coupons',
        breadcrumb: [
          {
            text: 'Codes promo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'Mon compte',
        pageTitleEn: 'My account',
        breadcrumb: [
          {
            text: 'Mon compte',
            active: true,
          },
        ],
      },
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/orders/Orders.vue'),
      meta: {
        pageTitle: 'Gains',
        pageTitleEn: 'Earns',
        breadcrumb: [
          {
            text: 'Gains',
            active: true,
          },
        ],
      },
    },
    {
      path: '/orders/detail/:id',
      name: 'orderDetail',
      component: () => import('@/views/orders/OrderDetail.vue'),
      meta: {
        pageTitle: 'Détail commande',
        pageTitleEn: 'Order detail',
        breadcrumb: [
          {
            text: 'Détail commande',
            active: true,
          },
        ],
      },
    },
    
    
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        pageTitleEn: 'Welcome',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
      props: true
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
